"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.function.name");

require("core-js/modules/es.parse-int");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.answers = exports["default"] = exports.genAgeOptions = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formElements = require("@evidation/form-elements");

var genAgeOptions = function genAgeOptions() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 18;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 110;
  var list = [{
    value: 0,
    label: "<".concat(min)
  }];

  for (var i = min; i <= max; i++) {
    list.push({
      value: i,
      label: "".concat(i)
    });
  }

  return list;
};

exports.genAgeOptions = genAgeOptions;

var Age = function Age(_ref) {
  var standardLabel = _ref.standardLabel,
      name = _ref.name,
      _onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    label: standardLabel,
    "data-test-id": "t-age-".concat(name)
  }, /*#__PURE__*/_react["default"].createElement(_formElements.SelectInput, {
    "data-test-id": "t-age",
    disableInitial: true,
    options: genAgeOptions(),
    onChange: function onChange(e) {
      return _onChange(parseInt(e.target.value, 10));
    },
    value: "".concat(value)
  }));
};

Age.defaultProps = {
  standardLabel: "What is your current age (in years)?",
  input: {}
};
Age.propTypes = {
  standardLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired
};

var _default = function _default(_ref2) {
  var input = _ref2.input,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["input"]);
  return /*#__PURE__*/_react["default"].createElement(Age, (0, _extends2["default"])({}, props, input));
};

exports["default"] = _default;
var answers = genAgeOptions();
exports.answers = answers;